import { VolumeDiscountRepository } from "public/repository/volume-discount.repository";

/**
 * @type {{name: string, timestamp: number}}
 */
const metadata = {
  name: "set-default-layout",
  timestamp: new Date("2026-03-16").getTime(),
};

/**
 * Set default layout to vertical
 * @param {Object} args
 * @param {Object} args.settings
 * @param {string} args.settings.namespace
 */
async function migrate({ settings }) {
  const volumeDiscountRepository = new VolumeDiscountRepository(settings);
  const volumeDiscounts = await volumeDiscountRepository.getAll();

  if (volumeDiscounts.items.length <= 0) {
    return;
  }

  if (volumeDiscounts.items.length >= 500) {
    console.log(
      `migrate:Volume Discounts collection is too large to migrate`,
      metadata.name
    );
    return;
  }

  for (const volumeDiscount of volumeDiscounts.items) {
    volumeDiscount.block.layout = "vertical";

    await volumeDiscountRepository.update(volumeDiscount);
  }
}

export default { metadata, migrate };
